export default __webpack_public_path__ + "static/scroll_phone_3-8dfa26b98ff5e51770ed8d2a005e2282.png";